import React from "react";
import { SectionHeader, DetailsHeaderTitle } from "../sectionHeader";
import { CloseButton } from "../buttons/closeButton";
import "./wizardHeader.scss";
import { type PublishedStatusType } from "enums";

type Props = {
  title?: string;
  titleForGA?: string;
  onClose: () => void;
  publishedStatus: PublishedStatusType;
  changeActiveIndex: (index: number) => void;
  renderCustomHeader?: (changeActiveIndex: (index: number) => void) => React.ReactNode;
};

function WizardHeader(props: Props) {
  const { title, titleForGA, publishedStatus, onClose, renderCustomHeader, changeActiveIndex } = props;
  return (
    <SectionHeader
      header={<DetailsHeaderTitle title={title} titleForGA={titleForGA} />}
      publishedStatus={publishedStatus}
      className="wizard-header"
    >
      <div className="custom-content-wrapper">
        {renderCustomHeader?.(changeActiveIndex)}
        <CloseButton id="close-wizard" testId="close-wizard" onClick={onClose} />
      </div>
    </SectionHeader>
  );
}

export default WizardHeader;
